@if (showSection) {
  <section class="section section--time pdf-page-wrapper">
    <div class="container">
      <h2 class="secondary-heading secondary-heading--white" [innerText]="'Your time off.' | translate"></h2>
      <h3 class="tertiary-heading tertiary-heading--white" [innerText]="'We care about your work life balance.' | translate"></h3>
      <div class="discs">
        @for (item of timeRewards; track trackByFn($index, item)) {
          <div class="discs__item">
            <div class="disc">
              <span class="disc__value" [innerText]="item.value || 0"></span>
              <span class="disc__time-unit" [innerText]="item.unit"></span>
            </div>
            <h4 class="quaternary-heading quaternary-heading--white" [innerText]="item.type | titlecase"></h4>
          </div>
        }
      </div>
    </div>
  </section>
}
